import type {AiPromptBox, AiPromptBoxReduxState} from '@Components/ai-prompt-box/ai-prompt-box.types';
import {AiPromptBoxSize, PromptBoxState} from '@Components/ai-prompt-box/ai-prompt-box.types';
import {PromptAttachmentDivider, PromptAttachmentType} from '@Components/ai-prompt-box/components/ai-prompt-box-attachments/ai-prompt-box-attachments.types';

export const aiPromptBoxInitialState = (): AiPromptBoxReduxState => {
  return {};
};

export const getDefaultAiPromptBoxState = (): AiPromptBox => {
  return {
    prompt: '',
    placeholder: '',
    size: AiPromptBoxSize.MEDIUM,
    promptBoxState: PromptBoxState.IDLE,
    showInitialAnimation: true,
    attachments: {
      items: [],
      dropdown: [PromptAttachmentType.IMAGE, PromptAttachmentDivider.HORIZONTAL_LINE, PromptAttachmentType.DESIGN],
    },
  };
};
